export const LABEL = {
  HOME: "Home",
  RESULTS: "Browse & Search",
  Configuration: "Configuration",
  CUSTOMERS: "Customers",
  CUSTOMER: "Customer",
  PROJECTS: "Projects",
  PROJECT: "Project",
  USERS: "Users",
  LOOKUPS: "Lookups",
} as const;
